module.exports = __webpack_public_path__ + "a99f7bce8de81196b96c9100d52b5373.pdf";